import { useState, useEffect } from 'react';
import axios from 'axios';
import PublishedArticle from './PublishedArticle';
import SEO from '../SEO';
import API_BASE_URL from '../../config';
import { Pagination } from './Pagination';

export type ArticleType = {
  _id: string;
  title: string;
  video?:  string | null;
  content?: string | null;
  image: string;
  publeshed: boolean;
  published_at: string;
};

type AllDataType = {
  articles: ArticleType[]; // Assuming ArticleType is another type you've defined
  totalPages: number; // Add totalPages property to match the expected structure
};

const PublishedArticles = () => {
  const [data, setData] = useState<AllDataType>({articles: [], totalPages: 1});
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const LIMIT = 3; // Number of articles per page

  useEffect(() => {
    const fetchData = async () => {
      try {
        const configuration = {
          url: `${API_BASE_URL}/published-articles?page=${currentPage}&limit=${LIMIT}`,
          method: 'get',
          headers: {
            'Content-Type': 'application/json',
          },
        }

        axios.request<AllDataType>(configuration).then(
          (res) => {
            const sortArticlesByDate = (articles: ArticleType[]): ArticleType[] => {
              return articles.sort((a, b) => new Date(b.published_at).getTime() - new Date(a.published_at).getTime());
            };

            if (res.data && res.data.articles) {
              const sortedArticles = sortArticlesByDate(res.data.articles);
              setTotalPages(res.data.totalPages)
              setData({ ...res.data, articles: sortedArticles, totalPages: res.data.totalPages });
            }
          }
          ).catch((err) => {
            console.error(err);
        });

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, [currentPage]); // Empty dependency array means this effect runs once on mount

  return (
    <div className="font-poppins container mx-auto space-y-6">
      <SEO
        title='AnittaMendezFitness: Ejercicios,Rutinas,Circuitos,Salud,Bienestar'
        description='Descubre cómo mejorar tu salud con circuitos y rutinas de ejercicio y motivación para lograr tus objetivos de fitness.'
        image='https://anittamendezfitness.com/static/media/logo-fitness.e7fde95318d7ca1fc76f.png'
        url='https://anittamendezfitness.com/published-articles'
      />
        {data?.articles.map(article => (
          <div className="relative overflow-x-auto shadow-2xl sm:rounded-lg mb-6 bg-gray-100" key={article._id}>
            <PublishedArticle article={article} imageURL={article.image} />
          </div>
        ))}
        <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={(page) => setCurrentPage(page)}></Pagination>
    </div>
  )
}

export default PublishedArticles
